import {rules as v} from '../scripts/rules';

const fotoliste = {
  "Fotonr"       : v.isNum,
 
  "Schnittnr"    : v.isNumManyWithoutDash,
  "Planumsnr"    : v.isNumManyWithoutDash,
  "Profilnr"     : v.isNumManyWithoutDash,
  "Befundnr"     : v.isNumManyWithoutDash,
  
  "Blickrichtung": v.isFreetext,
  "Bemerkung"    : v.isFreetext,
  "Datum"        : v.isDate,
  "UrheberIn"    : v.isFreetextNotEmpty,
}

export default fotoliste;
